// @ts-nocheck
import * as Types from '../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type HomeownerConfigurationsLandingPageQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CheckoutConfigsFilter>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type HomeownerConfigurationsLandingPageQuery = { __typename?: 'Query', checkoutConfigs: { __typename?: 'CheckoutConfigsPage', entities: Array<{ __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, status: Types.CheckoutConfigStatus, createdAt: Types.Scalars['DateTime']['input'], expiresAt?: Types.Scalars['Date']['input'] | null | undefined, totalPriceInCents: number, productOffering?: { __typename?: 'ProductOffering', id: string, name: string } | null | undefined, rendering?: { __typename?: 'Asset', id: string, largePreview?: string | null | undefined } | null | undefined, checkoutUrl: { __typename?: 'Url', path: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type HomeownerConfigurationsLandingPage_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, status: Types.CheckoutConfigStatus, createdAt: Types.Scalars['DateTime']['input'], expiresAt?: Types.Scalars['Date']['input'] | null | undefined, totalPriceInCents: number, productOffering?: { __typename?: 'ProductOffering', id: string, name: string } | null | undefined, rendering?: { __typename?: 'Asset', id: string, largePreview?: string | null | undefined } | null | undefined, checkoutUrl: { __typename?: 'Url', path: string } };

export const HomeownerConfigurationsLandingPage_CheckoutConfigFragmentDoc = gql`
    fragment HomeownerConfigurationsLandingPage_CheckoutConfig on CheckoutConfig {
  id
  name
  status
  createdAt
  expiresAt
  totalPriceInCents
  productOffering {
    id
    name
  }
  rendering {
    id
    largePreview: previewUrl(resizing: {width: 2500, region: FULL})
  }
  checkoutUrl {
    path
  }
}
    `;
export const HomeownerConfigurationsLandingPageDocument = gql`
    query HomeownerConfigurationsLandingPage($filter: CheckoutConfigsFilter, $page: PageFilter) {
  checkoutConfigs(filter: $filter, page: $page, order: {createdAt: DESC}) {
    entities {
      ...HomeownerConfigurationsLandingPage_CheckoutConfig
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${HomeownerConfigurationsLandingPage_CheckoutConfigFragmentDoc}`;

/**
 * __useHomeownerConfigurationsLandingPageQuery__
 *
 * To run a query within a React component, call `useHomeownerConfigurationsLandingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeownerConfigurationsLandingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeownerConfigurationsLandingPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useHomeownerConfigurationsLandingPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HomeownerConfigurationsLandingPageQuery, HomeownerConfigurationsLandingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomeownerConfigurationsLandingPageQuery, HomeownerConfigurationsLandingPageQueryVariables>(HomeownerConfigurationsLandingPageDocument, options);
      }
export function useHomeownerConfigurationsLandingPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomeownerConfigurationsLandingPageQuery, HomeownerConfigurationsLandingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomeownerConfigurationsLandingPageQuery, HomeownerConfigurationsLandingPageQueryVariables>(HomeownerConfigurationsLandingPageDocument, options);
        }
export type HomeownerConfigurationsLandingPageQueryHookResult = ReturnType<typeof useHomeownerConfigurationsLandingPageQuery>;
export type HomeownerConfigurationsLandingPageLazyQueryHookResult = ReturnType<typeof useHomeownerConfigurationsLandingPageLazyQuery>;
export type HomeownerConfigurationsLandingPageQueryResult = Apollo.QueryResult<HomeownerConfigurationsLandingPageQuery, HomeownerConfigurationsLandingPageQueryVariables>;